export function getSupergroupHierarchy(supergroup, supergroupMap) {
    const parentNames = [];
    let current = supergroupMap.get(supergroup.parent_id);
    while (current) {
        parentNames.unshift(current.name);
        current = supergroupMap.get(current.parent_id);
    }
    return parentNames.join(' > ');
}